import React from 'react';

export const VolEventYearModal = {
  title: 'Year',
  body: (
    <div>
      <p>
        The year of the eruption.
      </p>
    </div>
  ),
};
